import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CmsRole } from "../../apis/adminApis";

interface RoleState {
  roles: CmsRole[];
  needRefresh: boolean;
}

const initialState: RoleState = {
  roles: [],
  needRefresh: true,
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setRoles: (state, action: PayloadAction<CmsRole[]>) => {
      state.roles = action.payload;
      state.needRefresh = false;
    },
    setRoleNeedRefresh: (state, action: PayloadAction<boolean>) => {
      state.needRefresh = action.payload;
    },
  },
});

export const { setRoles, setRoleNeedRefresh } = roleSlice.actions;
export default roleSlice.reducer;
